var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiffId(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "29 589 24 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M41.6,595.49c0,3.15-2.56,5.71-5.71,5.71s-5.71-2.56-5.71-5.71,2.56-5.71,5.71-5.71,5.71,2.56,5.71,5.71ZM35.89,592.57c-1.61,0-2.92,1.31-2.92,2.92s1.31,2.92,2.92,2.92,2.92-1.31,2.92-2.92-1.31-2.92-2.92-2.92Z"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    x: 40.42,
    y: 593.92,
    width: 11.76,
    height: 3.14
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    x: 44.63,
    y: 595.99,
    width: 7.28,
    height: 3.14,
    transform: "translate(-549.29 645.83) rotate(-90)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiffId);
export default __webpack_public_path__ + "static/media/liff-id.52347c805061bd92398b55ed6e8a6cbf.svg";
export { ForwardRef as ReactComponent };